import {post,get, request} from '../../libs/ajax.js'
import qs from 'qs'

export default {

    /* 列表相关接口 */

    //  批量创建-列表-搜索下拉结果
    getSearchList:(data,options) => {
        return get('/oppo/batch/get_search_list', data, options);
    },
    //  批量创建-列表-列表汇总数据
    getTotalData:(data,options) => {
        return get('/oppo/batch/get_total', data, options);
    },
    //  批量创建-列表-列表数据
    getDataList:(data,options) => {
        return get('/oppo/batch/get_list', data, options);
    },
    //  批量创建-列表-列表目标账户
    getTargetAccount:(data,options) => {
        return get('/oppo/batch/get_target_account', data, options);
    },
    //  批量创建-列表详情页-搜索列表
    getDetailSearchList:(data,options) => {
        return get('/oppo/batch/get_detail_search_list', data, options);
    },
    //  批量创建-列表详情页-列表数据
    getDetailDataList:(data,options) => {
        return get('/oppo/batch/get_detail', data, options);
    },
    //  批量创建-列表详情页-列表汇总数据
    getDetailTotalData:(data,options) => {
        return get('/oppo/batch/get_detail_total', data, options);
    },
    //  批量创建-列表详情页-创意列表
    getDetailIdeaList:(data,options) => {
        return get('/oppo/batch/get_detail_idea_list', data, options);
    },

    /* 创建相关接口 */

    //  批量创建-账户列表
    getAccountList:(data,options) => {
        return get('/oppo/batch/get_account_list', data, options);
    },
    // 批量创建-计划列表
    getPlanList:(data,options) => {
        return get('/oppo/batch/get_plan_list', data, options);
    },
    // 批量创建-更新计划
    updatePlanList:(data,options) => {
        return post('/oppo/batch/update_plan_list', data, options);
    },
    // 批量创建-核实信息
    postPlanDetailInfo:(data,options) => {
        return post('/oppo/batch/get_plan_detail_info',data,options);
    },
    // 批量创建-检查预算
    checkBudget(data,options){
        return get('/oppo/batch/check_budget',data,options);
    },
    // 批量创建-获取产品列表
    getAppList(data,options){
        return get('/oppo/batch/get_app_list',data,options);
    },
    // 批量创建-校验产品落地页链接
    checkAppPackagePageUrl(data,options){
        return post('/oppo/batch/check_package_page_url',data,options);
    },


    // 批量创建-获取上传配置
    getUploadConfig(data,options){
        return post('/oppo/batch/get_upload_config',data,options);
    },
    // 批量创建-获取调用计划规格
    getSourcePlanConfig:(data,options) => {
        return get('/oppo/batch/source_plan_config',data,options);
    },
    // 批量创建-规格预览、生成预览
    taskPreview:(data,options) => {
        return post('/oppo/batch/preview', data, { timeout: 120* 1000 });
    },
    // 批量创建-修改广告监测链接
    modifyAdInfo(data,options){
        return post('/oppo/batch/modify_ad_info',data,options);
    },
    // 批量创建-预览信息step4
    taskPreviewInfo(data,options){
        return get('/oppo/batch/preview_info',data,options);
    },
    // 批量创建-预览信息step4
    taskPreviewAdList(data,options){
        return get('/oppo/batch/preview_ad_list',data,options);
    },
    // 批量创建-提交任务
    saveTask(data,options){
        return post('/oppo/batch/save',data,options);
    },
    // 批量创建-广告应用素材名称
    putMaterialNameToAdName(data,options){
        return post('/oppo/batch/put_material_name_to_ad_name',data,options);
    },
    // 批量创建-快应用支持 - 获取广告组配置
    getAdgroupConfig(data,options){
        return get('/oppo/batch/get_adgroup_config',data,options);
    },
    // 批量创建-快应用支持 - 获取打底网页地址
    getAdgroupList(data,options){
        return post('/oppo/batch/get_page_type_list',data,options);
    },
    // 批量创建-快应用支持 - 获取快应用信息
    getInstantInfo(data,options){
        return get('/oppo/batch/get_instant_app_info',data,options);
    },
    // 批量创建-快应用支持 - 快应用验证
    getInstantUrl(data,options){
        return post('/oppo/batch/check_instant_app_url',data,options);
    },
    // 批量创建-快应用支持 - 保存快应用信息
    postquick(data,options){
        return post('/oppo/batch/save_instant_app_info',data,options);
    },
    // 获取素材列表
    getWorkOrderMaterialList(data,options ={}){
        return request({
            url: '/oppo/batch/get_work_order_material_list',
            data: qs.stringify(data),
            method: 'post',
            ...options
        });
    },
    // 获取工单
    getOppoWorkOrderList(data){
        return post('/oppo/batch/get_work_order_list',data);
    },
    // 批量上传
    oppoBatchPpload(data,options){
        return request({
            url: '/oppo/batch/upload',
            data,
            method: 'post',
            ...options
        });
    },
    // 重试
    taskRetry(data){
        return post('/oppo/batch/task_retry',data);
    },
    // 搜索配置
    getWorkOrderSearchConfig(data,options){
        return get('/oppo/batch/get_work_order_search_config',data,options);
    },
}


